// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"209":"029d6862","891":"029d6862"}[chunkId] + ".chunk.css";
};